// Entity
import { ProgressTaskboardTaskFormattingBuilder } from "../../legacyPlanner/task/taskFormatting/ProgressTaskboardTaskFormattingBuilder";
/** Class to handle serialization/deserialization for TaskBoardFormatProgress data */ export class TaskBoardFormatProgressSerializationHandler {
    /** serialize to IGraphProgressTaskBoardTaskFormattingResource */ toSerializable(key, value) {
        return value.toGraphSerializable();
    }
    /** build IProgressTaskboardTaskFormatting from IGraphProgressTaskBoardTaskFormattingResource */ fromSerializable(key, serializableValue) {
        return new ProgressTaskboardTaskFormattingBuilder().fromGraphResource(serializableValue).build();
    }
}
